import { render, staticRenderFns } from "./prevencion-emergencias.vue?vue&type=template&id=a84e88fa&scoped=true&"
import script from "./prevencion-emergencias.vue?vue&type=script&lang=js&"
export * from "./prevencion-emergencias.vue?vue&type=script&lang=js&"
import style0 from "./prevencion-emergencias.vue?vue&type=style&index=0&id=a84e88fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84e88fa",
  null
  
)

export default component.exports